import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

export interface ICellRendererParamsForExpandCellRenderer extends ICellRendererParams {
    expand: (params: ICellRendererParamsForExpandCellRenderer) => void;
    collapse: (params: ICellRendererParamsForExpandCellRenderer) => void;
    showHiddenChildren: (params: ICellRendererParamsForExpandCellRenderer) => void;
    canExpand: (params: ICellRendererParamsForExpandCellRenderer) => boolean;
    canCollapse: (params: ICellRendererParamsForExpandCellRenderer) => boolean;
    canShowHiddenChildren: (params: ICellRendererParamsForExpandCellRenderer) => boolean;
    getName: (params: ICellRendererParamsForExpandCellRenderer) => string;
    getTooltip: (params: ICellRendererParamsForExpandCellRenderer) => string;
}

@Component({
    selector: 'expand-cell',
    template: `
<span class="expand-controls">
  @if (params.canCollapse(params)) {
    <span class="fa node-expanded" (click)="params.collapse(params)" title="Collapse"></span>
  }
  @if (params.canExpand(params)) {
    <span class="fa node-collapsed" (click)="params.expand(params)" title="Expand"></span>
  }
</span>
<span [title]="params.getTooltip(params)">{{ params.getName(params) }}</span>
@if (params.canShowHiddenChildren(params)) {
  <a (click)="params.showHiddenChildren(params)" title="Show Children Unfiltered"> ( +  )</a>
}`,
    standalone: false
})
export class ExpandCellRendererComponent implements ICellRendererAngularComp {
    params: ICellRendererParamsForExpandCellRenderer;

    agInit(params: ICellRendererParamsForExpandCellRenderer): void {
        this.params = params;
    }

    refresh(): boolean {
        return false; // tells grid to handle refreshing
    }
}
